import { Link, useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import SocieteService from "../../services/Societe";
import KPISaleService from "../../services/KPISaleService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import KPIProduitsService from "../../services/KPIProduitsService";
import DataTableProducts from "../../ui/DataTableProducts";
import { ListGroup, Row, Card, Col } from "react-bootstrap";
// Static years options
// const yearsOptions = [
//   { value: 2020, label: '2020' },
//   { value: 2021, label: '2021' },
//   { value: 2022, label: '2022' },
//   { value: 2023, label: '2023' },
//   { value: 2024, label: '2024' }
// ];

// Helper function to render tables for transfers
const renderTransferTable = (currentPage, setCurrentPage, transfers, title) => {
  const itemsPerPage = 5; // Define how many items you want per page

  // Calculate the total number of pages
  const totalPages = Math.ceil(transfers.length / itemsPerPage);

  // Get current transfers to display
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTransfers = transfers.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const goToNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const goToPreviousPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

  return (
    <section className="content col-12">
      <div className="card mt-3">
        <div className="card-header">
          <h3 className="card-title">{title}</h3>
          <div className="card-tools">
            <button type="button" className="btn btn-tool" data-card-widget="collapse" title="Collapse">
              <i className="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <div className="card-body p-0">
          <table className="table projects">
            <thead>
              <tr className="text-center">
                <th style={{ width: "12%" }}>Name</th>
                <th style={{ width: "12%" }}>Commande</th>
                <th style={{ width: "12%" }}>Quantité Totale</th>
                <th style={{ width: "12%" }}>Prix Initial</th>
                <th style={{ width: "12%" }}>Prix de Vente</th>
                <th style={{ width: "12%" }}>Promotion (%)</th>
              </tr>
            </thead>
            <tbody>
              {currentTransfers.map((element) => (
                <tr className="text-center" key={element._id}>
                  <td>{element.name}</td>
                  <td>{element.count}</td>
                  <td>{element.total_quantity}</td>
                  <td>{element.totalAmountInitialPrice}</td>
                  <td>{element.totalAmountSellingPrice}</td>
                  <td>{element.promotionPercentage}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className=" col-12 d-flex justify-content-center align-items-center ">
            <div className="pagination my-3 d-flex justify-content-center align-items-center">
              <button
                onClick={goToPreviousPage}
                disabled={currentPage === 1}
                className="btn btn-secondary mr-2"
              >
                Previous
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button
                onClick={goToNextPage}
                disabled={currentPage === totalPages}
                className="btn btn-secondary ml-2"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


const KPISaleDevis = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  const animatedComponents = makeAnimated();
  const [yearPlaceholder, setYearPlaceholder] = useState("");
  const [dataByYear, setDataByYear] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isClicked, setIsClicked] = useState(false);
  const [selectedYear, setSelectedYear] = useState(null);
  const [finalYear, setFinalYear] = useState("");
  const [yearsOptions, setYearsOptions] = useState([]);
  useEffect(() => {
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          const today = new Date();

          const yyyy = today.getFullYear();

          setFinalYear(yyyy);
          setYearPlaceholder(yyyy);

          const yearsOptions = response.data["success"].years.map(
            (year, index) => ({
              value: index,
              label: year,
            })
          );
          setYearsOptions([...yearsOptions]);
        }
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  }, []);

  // const [yearsOptions, setYearsOptions] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);

  const monthsOptions = [
    { value: 1, label: "Janvier" },
    { value: 2, label: "Février" },
    { value: 3, label: "Mars" },
    { value: 4, label: "Avril" },
    { value: 5, label: "Mai" },
    { value: 6, label: "Juin" },
    { value: 7, label: "Juillet" },
    { value: 8, label: "Août" },
    { value: 9, label: "Septembre" },
    { value: 10, label: "Octobre" },
    { value: 11, label: "Novembre" },
    { value: 12, label: "Décembre" }
  ];

  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
    setFinalYear(selectedOption.label);
    console.log(`Option selected:`, selectedOption);
  };

  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
    console.log(`Month selected:`, selectedOption);
  };
  useEffect(() => {
    const fetchData = () => {
      // Check if selectedYear and selectedMonth.value are valid
      if (selectedYear && !selectedMonth) {
        console.log(selectedYear); // Log selectedYear.value only if it's available
        setIsClicked(true);

        try {
          startLoading();
          setDataByYear([])
           KPIProduitsService.getProductsByDevisAndYear(getCurrentUserId(), selectedYear.value).then((response) => {
            setDataByYear(response.data);
           }).catch((error)=>{
            console.log(error);
          }).finally(() => {
            stopLoading();
          })
          

         
        } catch (error) {
          console.log("error: " + error);
        } 
        // finally {
        //   stopLoading();
        // }
      } else if (selectedYear && selectedMonth) {
        setIsClicked(true);

        try {
          startLoading();

          setDataByYear([])

          KPIProduitsService.getProductsByDevis(getCurrentUserId(), selectedMonth.value, selectedYear.value).then((response)=>{
            setDataByYear(response.data);
          }).catch((error)=>{
            console.log(error);
          }).finally(() => {
            stopLoading();
          })

         
        } catch (error) {
          console.log("error: " + error);
        } 
        // finally {
        //   stopLoading();
        // }
      }
    };

    fetchData();
  }, [selectedYear, selectedMonth]); // Only re-run if selectedYear or selectedMonth changes


  useEffect(() => {
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          const today = new Date();
          const yyyy = today.getFullYear();

          setFinalYear(yyyy);
          setYearPlaceholder(yyyy);

          // Set current year as the default selected year
          const yearsOptions = response.data["success"].years.map((year, index) => ({
            value: index,
            label: year,
          }));

          // setYearsOptions([...yearsOptions]);

          // Set the default selected year to the current year
          setSelectedYear({ value: yyyy, label: yyyy.toString() });
        }
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  }, []);

  const goToProductHandler = () => {
    navigate(`/kpisaleproduct`);
  };
  const filterTableProduct = (listProduits) => {
    if (listProduits && listProduits.length > 0) {
      return <DataTableProducts listProduits={listProduits} kpisale={true} />;
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>Home</Link>
                </li>
                <li className="breadcrumb-item active" style={{ color: "black" }}>
                  Les KPI de Vente
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            {/*<div className="col-sm-12">
              <button
                type="submit"
                onClick={goToProductHandler}
                className="btn btn-dark float-right"
              >
                Voir les produits
              </button>
              <button
                type="submit"
                onClick={goToProductHandler}
                className="btn btn-dark float-right mr-1"
              >
                Voir Devis
              </button>
  </div>*/}
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Choisir un an</h3>
                </div>
                <div className="card-body d-flex justify-content-center align-items-center">
                  <div className="form-group col-6 col-sm-6">
                    <label>Choisir l'année</label>
                    <Select
                      value={selectedYear}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={yearsOptions}
                      onChange={handleYearChange}
                      placeholder="Sélectionner l'année"
                    />
                  </div>

                  <div className="form-group col-6 col-sm-6">
                    <label>Choisir le mois</label>
                    <Select
                      value={selectedMonth}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={monthsOptions}
                      onChange={handleMonthChange}
                      placeholder="Sélectionner le mois"
                    />
                  </div>
                </div>

                {/* <div className="card-footer">
                  <button
                    type="submit"
                    onClick={getKPISale}
                    className="btn btn-dark float-right"
                  >
                    Valider
                  </button>
                  </div>*/}
              </div>
              {dataByYear && dataByYear?.minAmount ?
                <div className="row">
                <div className="col-lg-4 col-6">
                  {/* small box */}
                  <div className="small-box bg-info">
                    <div className="inner">
                      <h3>{dataByYear?.minAmount || 0} DT</h3>
                      <p>Montant minimum</p>
                    </div>
                  </div>
                </div>
                {/* ./col */}
                <div className="col-lg-4 col-6">
                  {/* small box */}
                  <div className="small-box bg-success">
                    <div className="inner">
                      <h3>
                        {dataByYear?.maxAmount || 0} DT
                      </h3>
                      <p>Montant maximum</p>
                    </div>
                  </div>
                </div>
                {/* ./col */}
                <div className="col-lg-4 col-6">
                  {/* small box */}
                  <div className="small-box bg-warning">
                    <div className="inner">
                      <h3> {dataByYear?.ttQte || 0} </h3>
                      <p>Quantité totale</p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Row>
                    {[dataByYear?.top1, dataByYear?.top2, dataByYear?.top3].map((top, index) => (
                      <Col lg={4} md={4} key={index}>
                        <Card className="mb-3">
                          <Card.Body className="text-center">
                            <div
                              className="profile-user-img img-fluid img-circle mb-2 bg-info d-flex"
                              style={{ width: "108px", height: "108px", justifyContent: "center", alignItems: "center" }}
                            >
                              <h3>{index + 1}</h3>
                            </div>
                            <h3 className="profile-username" style={{height:"75px"}}>{top?.productCode + "-" + top?.barcode + "-" + top?.name}</h3>
                            <p className="text-muted">{`top${index + 1}`}</p>
                            <ListGroup variant="flush">
                              <ListGroup.Item>
                                <div className="d-flex justify-content-between">
                                  <strong>Commande</strong>
                                  <span>{top?.count}</span>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item>
                                <div className="d-flex justify-content-between">
                                  <strong>Quantité Totale</strong>
                                  <span>{top?.total_quantity}</span>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item>
                                <div className="d-flex justify-content-between">
                                  <strong>Prix initial</strong>
                                  <span>{top?.totalAmountInitialPrice} DT</span>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item>
                                <div className="d-flex justify-content-between">
                                  <strong>Prix de vente</strong>
                                  <span>{top?.totalAmountSellingPrice} DT</span>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item>
                                <div className="d-flex justify-content-between">
                                  <strong>Promotion (%)</strong>
                                  <span>{top?.promotionPercentage}</span>
                                </div>
                              </ListGroup.Item>
                            </ListGroup>

                            {/* <Button variant="primary" block className="mt-2 w-75 bg-info">
            <b>Lire la suite</b>
          </Button> */}
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>

                </div>
                {dataByYear?.list && filterTableProduct(dataByYear?.list)}
                {/*dataByYear?.list && dataByYear?.list.length > 0 && renderTransferTable(currentPage, setCurrentPage,dataByYear?.list, "Product")*/}
                </div> :
                <div> </div>}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(KPISaleDevis);
